"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRequestAccountDeletionDto = instanceOfRequestAccountDeletionDto;
exports.RequestAccountDeletionDtoFromJSON = RequestAccountDeletionDtoFromJSON;
exports.RequestAccountDeletionDtoFromJSONTyped = RequestAccountDeletionDtoFromJSONTyped;
exports.RequestAccountDeletionDtoToJSON = RequestAccountDeletionDtoToJSON;
exports.RequestAccountDeletionDtoToJSONTyped = RequestAccountDeletionDtoToJSONTyped;
/**
 * Check if a given object implements the RequestAccountDeletionDto interface.
 */
function instanceOfRequestAccountDeletionDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function RequestAccountDeletionDtoFromJSON(json) {
    return RequestAccountDeletionDtoFromJSONTyped(json, false);
}
function RequestAccountDeletionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
function RequestAccountDeletionDtoToJSON(json) {
    return RequestAccountDeletionDtoToJSONTyped(json, false);
}
function RequestAccountDeletionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
    };
}
